import SubHeaders from '@/components/Headers/SubHeaders'
import useTabs from '@/hooks/useTabs'
import { paths } from '@/utils/path'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'
import { Tabs } from 'vnetwork-ui'
import ContractButtons from '../../shared/Buttons'
import Statistical from './Statistical'
import { tabs } from './tab'

const Overview = () => {
    const { t } = useTranslation()
    const { type } = useParams<{ type: string }>()
    const { TabComponent, TabProps } = useTabs({ tabs })
    return (
        <div className="mb-4">
            <SubHeaders
                breadcrumbs={[
                    {
                        path: paths.customerContractList,
                        title: t('contract-list'),
                    },
                    {
                        path: paths.customerContractOverview,
                        title: t(`contract-${type}`),
                    },
                ]}
            />
            <Statistical />
            <div className="flex justify-between items-center">
                <Tabs {...TabProps} className="!px-2" />
                <ContractButtons.Export />
            </div>
            {TabComponent}
        </div>
    )
}

const OverviewContractType = () => <Overview />
export default OverviewContractType
